'use strict';

module.exports = {
    /**
     * Update the Home Store label and link in the nav header (populated by content asset)
     * @param {string} storeName - the customer's preferred store name
     * @param {string} storeId - the customer's preferred store ID
     */
    updateStoreLink: function (storeName, storeId) {
        var $storeLink = $('#sub-nav-store-name');
        var $storeLabel = $storeLink.find('.store-name-label');

        $storeLink.removeClass('d-none');
        $storeLink.attr('href', `/search/?store=${storeId}`);
        $storeLabel.text(storeName);

        const $storeInfo = $('#sub-nav-store-info');
        if ($storeInfo) {
            $storeInfo.data('preferred-store-id', storeId);
            $storeInfo.find('.store-name').text(storeName);
        }
    }
};
